@use './variables' as *;

:host {
  display: $list-host-display;
}

.list-item {
  display: $list-display;
  flex-direction: $list-flex-direction;
  margin-top: $list-margin-top;
  margin-right: $list-margin-right;
  margin-bottom: $list-margin-bottom;
  margin-left: $list-margin-left;
  padding-top: $list-padding-top;
  padding-right: $list-padding-right;
  padding-bottom: $list-padding-bottom;
  padding-left: $list-padding-left;
}
